import {
  Title,
  Button,
  Animation,
  TabFooter,
  SelectedItemsContainer,
  ItemsPickContainer,
  ButtonsContainer,
} from '../../../styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { CollapseItemMachineryItems } from './CollapseItemMachineryItems'
import { ItemsPick } from 'components/ItemsPick/ItemsPick'
import { IMachineModelSimple } from 'types/machineModels.interface'
import { IInventoryItem, IItemsTab } from 'types/inventory.interface'

export const InventoryItemsMachineryTab = ({ state, setState, setActive }: IItemsTab) => {

  const handleAdd = (item: IMachineModelSimple) => {
    if (!state.machineModels.some((i) => i.id == item.id)) {
      const parsedItem = {
        id: item.id,
        priority: 0,
        rating: 0,
        name: item.name,
      }
      setState((prev: IInventoryItem) => {
        const copy = { ...prev }
        copy.machineModels = [...copy.machineModels, parsedItem]
        return copy
      })
    } else {
      setState((prev: IInventoryItem) => {
        const copy = { ...prev }
        copy.machineModels = copy.machineModels.filter((m) => m.id !== item.id)
        return copy
      })
    }
  }

  const handleNext = () => {
    setActive('Capabilities')
  }

  return (
    <Animation>
      <ItemsPickContainer>
        <SelectedItemsContainer>
          <Title pad='0 20px'>Selected Models</Title>
          {state?.machineModels?.map((item) => {
            return <CollapseItemMachineryItems setState={setState} key={item.id} data={item} />
          })}
        </SelectedItemsContainer>
        <ItemsPick
          placeholder='Search machine models...'
          handleAdd={handleAdd}
          link='machine-models'
          selectedList={state?.machineModels}
          parserFunction={data => data.data.map(d => ({ id: d.machineModel.id, name: d.machineModel.make + ' ' + d.machineModel.model }))}
        />
      </ItemsPickContainer>
      <TabFooter>
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}